import { Component, OnInit } from '@angular/core';
import { Permission } from '@models/permission.model';
import { SideNavBar, SideNavBarItem } from '@models/side-nav-bar.model';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '@services/permissions.service';
import { CredentialsApiService } from '@services/api-calls/credentials-api.service';

@Component({
    selector: 'app-side-nav-bar',
    templateUrl: './side-nav-bar.component.html',
    styleUrls: ['./side-nav-bar.component.scss'],
})
export class SideNavBarComponent implements OnInit {
    public sideNavBar?: SideNavBar;
    public permissions: Permission[];
    public userAccessId: string = localStorage.getItem('user-access');

    constructor(
        private translate: TranslateService,
        private permissionService: PermissionService,
        private credentialApiService: CredentialsApiService
    ) {}

    ngOnInit(): void {
        this.permissions = this.permissionService.permissionsValue;

        this.translate.get('HOME.deals').subscribe((translated: string) => {
            const items = [
                new SideNavBarItem(translated, 'assessment', '/deals', [
                    'read_dealflow_dashboard',
                ]),
                new SideNavBarItem(
                    this.translate.instant('HOME.investors'),
                    'group',
                    '/investors',
                    ['read_investors', 'crud_investors']
                ),
                new SideNavBarItem(
                    this.translate.instant('HOME.funnel'),
                    'filter_list',
                    '/funnel',
                    ['read_dealflow', 'crud_dealflow']
                ),
            ];
            this.sideNavBar = new SideNavBar('assets/images/logo.svg', items);
        });

        if (!this.permissions && this.userAccessId) {
            this.credentialApiService.getUserAccess().subscribe(
                (response) => {
                    const permissions = response.find(
                        (userAccess) => userAccess.id === this.userAccessId
                    ).role.permissions;
                    this.permissionService.setPermissions(permissions);
                    this.permissions = permissions;
                    this.sideNavBar?.setItemsVisibility(this.permissions);
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            this.sideNavBar?.setItemsVisibility(this.permissions);
        }
    }
}
